import { render, staticRenderFns } from "./EmailAuthorizationDashboard.vue?vue&type=template&id=66b3b8e0&scoped=true"
import script from "./EmailAuthorizationDashboard.vue?vue&type=script&lang=js"
export * from "./EmailAuthorizationDashboard.vue?vue&type=script&lang=js"
import style0 from "./EmailAuthorizationDashboard.vue?vue&type=style&index=0&id=66b3b8e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b3b8e0",
  null
  
)

export default component.exports